import React, { useState } from "react";
import { Container, Row, Col, Form, Button, Spinner } from 'react-bootstrap';
import style from './ReportAnIssue.module.css';
import { useTranslation } from 'react-i18next';
import { Alert } from "../../utils";
import { Toaster } from "sonner";
import axios from "axios";

const ReportAnIssue = () => {
  const [formData, setFormData] = useState({ email: "", issueType: "", description: "", screenshot: "", deviceType: "", browser: "", formType: "Report An Issue" });
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();

  const handleFormControl = (e) => {
    const { name, value, files } = e.target;

    if (name === "screenshot") {
      setFormData({ ...formData, [name]: files[0] });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);

    const email = e.target.email.value;
    const issueType = e.target.issueType.value;
    const description = e.target.description.value;
    const deviceType = e.target.deviceType.value;
    const browser = e.target.browser.value;

    if (email === "") {
      setLoading(false);
      return Alert.error("You must enter an email");
    }
    if (issueType === "") {
      setLoading(false);
      return Alert.error("You must enter an issue type");
    }
    if (description === "") {
      setLoading(false);
      return Alert.error("You must enter a description");
    }
    if (deviceType === "") {
      setLoading(false);
      return Alert.error("You must select a device type");
    }
    if (browser === "") {
      setLoading(false);
      return Alert.error("You must select a browser");
    }
    try {
      handleSendEmail(formData);
      setLoading(false);
      setSubmitted(true);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  }

  const handleSendEmail = async (dataEmail) => {
    const formData = new FormData();

    for (const key in dataEmail) {
      formData.append(key, dataEmail[key]);
    }

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL_V2}/api/send-email/form`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
          timeout: 60000, // Timeout de 60 segundos
        }
      );
      //console.log("Respuesta del servidor:", response);
    } catch (error) {
      console.error(error);
      throw error;
    }
  };

  return (
    <Container className="p-0" fluid>
      <Row className={`m-0 py-4 py-md-5 justify-content-center ${style.header}`}>
        <Col xs={11} md={7} lg={6} className='align-content-center'>
          <h1 className={`mb-md-4 ${style.headerTitle}`}>
            {t("Report an Issue")}
          </h1>
        </Col>
      </Row>
      <Row className='justify-content-center my-4 mx-0'>
        <Col xs={11} md={6} lg={6} xl={5} className='mt-4'>
          <p className={style.txt}>{t("reportAnIssueTxt1")}</p>
        </Col>
      </Row>
      <Row className='justify-content-center my-4 mx-0'>
        <Col xs={11} md={7} lg={6} xl={5} className='align-content-center mb-4'>
          <Form onSubmit={handleSubmit} className="mt-2">
            <Row>
              <Col xs={12} md={6}>
                <Form.Group className="mb-3" controlId="email">
                  <Form.Label className={style.formLabels}>{t("Email address")}</Form.Label>
                  <Form.Control
                    isInvalid={
                      formData.email.length > 0 &&
                      !formData.email.match(
                        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                      )
                    }
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleFormControl}
                    className={style.formInputs}
                  />
                  <Form.Control.Feedback type="invalid">
                    {t("You must write a valid email")}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col xs={12} md={6}>
                <Form.Group className="mb-3" controlId="issueType">
                  <Form.Label className={style.formLabels}>{t("Issue type")}</Form.Label>
                  <Form.Select
                    name="issueType"
                    value={formData.issueType}
                    onChange={handleFormControl}
                    className={style.formInputs}
                  >
                    <option value="">{t("Select issue type")}</option>
                    <option value="Bug or technical">{t("Bug or Technical Error")}</option>
                    <option value="Login or account">{t("Login/Account Issue")}</option>
                    <option value="Other">{t("Other")}</option>
                  </Form.Select>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col xs={12}>
                <Form.Group className="mb-3" controlId="description">
                  <Form.Label className={style.formLabels}>{t("Description")}</Form.Label>
                  <Form.Control
                    as="textarea"
                    name="description"
                    value={formData.description}
                    onChange={handleFormControl}
                    className={style.formInputs}
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col xs={12}>
                <Form.Group controlId="formFileSm" className="mb-3">
                  <Form.Label className={style.formLabels}>{t("Screenshot (optional)")}</Form.Label>
                  <Form.Control
                    type="file"
                    size="sm"
                    name="screenshot"
                    onChange={handleFormControl}
                    className={style.formInputs}
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col xs={12} md={6}>
                <Form.Group className="mb-3" controlId="deviceType">
                  <Form.Label className={style.formLabels}>{t("Device type")}</Form.Label>
                  <Form.Select
                    name="deviceType"
                    value={formData.deviceType}
                    onChange={handleFormControl}
                    className={style.formInputs}
                  >
                    <option value="">{t("Select device type")}</option>
                    <option value="Mobile">{t("Mobile")}</option>
                    <option value="Desktop">{t("Desktop")}</option>
                    <option value="Tablet">{t("Tablet")}</option>
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col xs={12} md={6}>
                <Form.Group className="mb-3" controlId="browser">
                  <Form.Label className={style.formLabels}>{t("Browser")}</Form.Label>
                  <Form.Select
                    name="browser"
                    value={formData.browser}
                    onChange={handleFormControl}
                    className={style.formInputs}
                  >
                    <option value="">{t("Select browser")}</option>
                    <option value="Chrome">Chrome</option>
                    <option value="Safari">Safari</option>
                    <option value="Mozilla Firefox">Mozilla Firefox</option>
                  </Form.Select>
                </Form.Group>
              </Col>
            </Row>
            {submitted ?
              <Button type="submit" className={style.submitBtn} disabled={true}>
                {t("Thank you!")}
              </Button>
              :
              <Button type="submit" className={style.submitBtn}>
                {t("Submit")}{" "}
                {loading && (
                  <Spinner
                    as="span"
                    size="sm"
                    animation="grow"
                    role="status"
                  />
                )}
              </Button>
            }
          </Form>
          <Toaster richColors position="bottom-center" closeButton />
        </Col>
      </Row>
    </Container>
  )
}

export default ReportAnIssue;